// noinspection JSUnresolvedVariable,JSUnresolvedFunction
import i18n from '@/i18n'
import VueRouter from 'vue-router'
import Vue from 'vue'
import api from '@/api'
import store from '@/store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "home" */ './pages/kyc/HomeKyc')
  },
  {
    path: '/scan',
    name: 'Scan',
    component: () =>
      import(/* webpackChunkName: "scan" */ './pages/iframe/IFrameScan')
  },
  {
    path: '/upload',
    name: 'Upload',
    component: () =>
      import(/* webpackChunkName: "upload" */ './pages/iframe/IFrameUpload')
  },
  {
    path: '/eezee',
    name: 'Eezee',
    component: () =>
      import(/* webpackChunkName: "eezee" */ './pages/eezee/HomeEezee.vue')
  },
  {
    path: '/eezee/confirm',
    name: 'ConfirmEezee',
    component: () =>
      import(/* webpackChunkName: "confirm" */ './pages/eezee/ConfirmEezee.vue')
  },
  {
    path: '/eezee/success',
    name: 'SuccessEezee',
    component: () =>
      import(/* webpackChunkName: "success" */ './pages/eezee/SuccessEezee.vue')
  },
  {
    path: '/rbmz',
    name: 'Eezee',
    component: () =>
        import(/* webpackChunkName: "eezee" */ './pages/eezee/HomeEezee.vue')
  },
  {
    path: '/rbmz/confirm',
    name: 'ConfirmEezee',
    component: () =>
        import(/* webpackChunkName: "confirm" */ './pages/eezee/ConfirmEezee.vue')
  },
  {
    path: '/rbmz/success',
    name: 'SuccessEezee',
    component: () =>
        import(/* webpackChunkName: "success" */ './pages/eezee/SuccessEezee.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  // eslint-disable-next-line no-undef
  if (gtag) {
    // eslint-disable-next-line no-undef
    gtag('event', 'page_view', {
      page_location: to.path,
      page_title: to.name
    })
  }

  if ((to.path === '/upload' || to.path === '/scan') && to.query.t) {
    console.log(to.query)
    if (['ar', 'en'].includes(to.query.language)) {
      // noinspection JSValidateTypes
      i18n.locale = to.query.language
    }
    try {
      const { data } = await api.validateToken(to.query.t)
      if (data) {
        store.state.embedTokenData = data
        store.state.embedAuth = true
      }
    } catch (e) {
      store.state.embedTokenData = null
      store.state.embedAuth = false
    } finally {
      store.state.loading = false
    }
  }

  if (!to.query.t) {
    await store.dispatch('queryCustomerStatus', to.path)
    await store.dispatch('loadPaciRequestFromStorage')

    if ((store?.state?.queryIdInfoResult?.status === 'Active' || store?.state?.isPaciAuthenticated) && to?.name !== 'SuccessEezee') {
      return next({name: 'SuccessEezee'})
    }


    store.state.loading = false
  }


  if (to.path.startsWith('/eezee') || to.path.startsWith('/rbmz')) {
    if(to.query.mock) {
      store.state.isMock = to.query.mock === 'true'
    }
    if(store.state.paciRequestId) {
      store.dispatch('reQueryPaci').then()
    }
  }

  if (to.path.startsWith('/eezee') && store.state.isRBPRAL) {
    next(to.path.replace('eezee', 'rbmz'))
  }

  if(to.path.startsWith('/rbmz') && !store.state.isRBPRAL) {
    next(to.path.replace('rbmz', 'eezee'))
  }

  next()
})

export default router
